import teamService from "../services/index";

export default {
  state: {
    myRole: "owner",
    myPermissions: [],
    myEmissionPoints: [],
    permissionsLoaded: false,
    loadingPromise: null
  },
  mutations: {
    setMyRole(state, role) {
      state.myRole = role;
    },
    setMyPermissions(state, permissions) {
      state.myPermissions = permissions;
    },
    setMyEmissionPoints(state, emissionPoints) {
      state.myEmissionPoints = emissionPoints;
    },
    setPermissionsLoaded(state, loaded) {
      state.permissionsLoaded = loaded;
    },
    setLoadingPromise(state, promise) {
      state.loadingPromise = promise;
    }
  },
  actions: {
    async loadMyPermissions({ commit, state }, params = {}) {
      // Una sola carga en vuelo: el layout y el guard del router la piden.
      if (state.loadingPromise) return state.loadingPromise;
      const promise = (async () => {
        try {
          const response = await teamService.getMyPermissions(params);
          if (response.data.success) {
            const { role, permissions, emission_points } = response.data.data;
            commit("setMyRole", role);
            commit("setMyPermissions", permissions);
            commit("setMyEmissionPoints", emission_points);
            commit("setPermissionsLoaded", true);
          }
        } catch {
          // Si no se pueden cargar no se oculta nada (el backend sigue
          // aplicando los permisos y responde 403 donde corresponda).
          commit("setMyRole", "owner");
          commit("setMyPermissions", ["*"]);
          commit("setPermissionsLoaded", true);
        }
      })();
      commit("setLoadingPromise", promise);
      try {
        await promise;
      } finally {
        commit("setLoadingPromise", null);
      }
    },
    clearPermissions({ commit }) {
      commit("setMyRole", "owner");
      commit("setMyPermissions", []);
      commit("setMyEmissionPoints", []);
      commit("setPermissionsLoaded", false);
    }
  },
  getters: {
    myRole: state => state.myRole,
    myPermissions: state => state.myPermissions,
    myEmissionPoints: state => state.myEmissionPoints,
    permissionsLoaded: state => state.permissionsLoaded,

    hasPermission: state => permission => {
      // Antes de cargar no se oculta nada: el backend igual rechaza con 403.
      if (!state.permissionsLoaded) return true;
      if (state.myRole === "owner") return true;
      const perms = state.myPermissions || [];
      if (perms.includes("*")) {
        // Admin: todo salvo lo negado explícitamente ("denied:a,b").
        const denied = perms
          .filter(p => typeof p === "string" && p.startsWith("denied:"))
          .flatMap(p => p.slice(7).split(","))
          .filter(Boolean);
        return !denied.includes(permission);
      }
      return perms.includes(permission);
    },

    canUseEmissionPoint: state => epId => {
      if (state.myRole === "owner") return true;
      // Sin puntos asignados = todos.
      if (!state.myEmissionPoints || !state.myEmissionPoints.length)
        return true;
      return state.myEmissionPoints.some(ep => ep.id === epId);
    },

    hasAnyPermission: (state, getters) => permissions =>
      permissions.some(p => getters.hasPermission(p))
  }
};
